import { getAppUrl } from "../config";

const normalizeBaseUrl = (url: string) => {
	return url.endsWith("/") ? url.slice(0, -1) : url;
};

export const getAccountLoginUrl = () => {
	const baseUrl = normalizeBaseUrl(getAppUrl("accountApp"));
	return `${baseUrl}/login`;
};

export const getAccountRegisterUrl = () => {
	const baseUrl = normalizeBaseUrl(getAppUrl("accountApp"));
	return `${baseUrl}/register`;
};

export const getTicketAppHomeUrl = () => {
	const baseUrl = normalizeBaseUrl(getAppUrl("ticketApp"));
	return `${baseUrl}/`;
};
